import type { ReactNode } from 'react'
import { Button, Card, Heading } from '@autoplan/web-ui'

type TaskCardProps = {
  icon: ReactNode
  label: string
  buttonLabel: string
  onClick: () => void
}

export const InformationCard = ({ icon, label, buttonLabel, onClick }: TaskCardProps) => {
  return (
    <Card className="ap:p-2xl">
      <div className="ap:flex ap:items-center ap:justify-between ap:gap-xl">
        <div className="ap:flex ap:items-center ap:gap-md ap:min-w-0">
          <span className="ap:text-content-secondary ap:shrink-0">{icon}</span>
          <Heading size="md" className="ap:truncate">
            {label}
          </Heading>
        </div>
        <Button variant="secondary" onClick={onClick}>
          {buttonLabel}
        </Button>
      </div>
    </Card>
  )
}
